/**
 *
 * @module commerceClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class CommerceClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the CommerceClient.
 *
 */
export default class CommerceClientConfiguration extends ServiceClientConfiguration {

    /**
     *
     * @param {String} baseUrl
     * @param {Object} endpoints
     * @param {CommerceClientExtrasMap} extras
     *
     */
    constructor(baseUrl, endpoints, extras) {

        super(baseUrl, endpoints);

        /**
         *
         * @access public
         * @type {CommerceClientExtrasMap}
         *
         */
        this.extras = extras;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/commerceClientConfiguration.js